// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n:root {\n  --c-top-bar-height: 48px;\n  --c-bottom-bar-height: 72px;\n  --c-footer-height: 48px;\n  --c-footer-height: 0px;\n}\n.c-app-layout {\n  background-color: var(--v-sheet-base);\n  height: 100%;\n  overflow-y: visible;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
